export const team_members_data = {
    'es' : [
        {
            'name'          : 'Darío Riquelme Z.',
            'position'      : 'Director',
            'image'         : "/images/team/D_Dario.jpg",
            'links'         : {
                'linkedin'  : 'https://www.linkedin.com/in/dario-riquelme-zornow/'
            }
        },
        {
            'name': 'Javiera Klein M.',
            'position': 'Líder de Gestión y Proyectos',
            'image': "/images/team/G_Javiera.jpg",
            'links': {
                'linkedin': 'https://www.linkedin.com/in/javiera-klein/'
            }
        },
        {
            'name'          : 'Cecilia Pereira A.',
            'position'      : 'Editora Asistente',
            'image'         : "/images/team/G_CeciliaPereira.jpg",
            'links'         : {
                'linkedin'  : 'https://www.linkedin.com/in/cecilia-andrea-pereira-alvarez-915b8a32/'
            }
        },
        {
            'name'          : 'Paulina Gatica M.',
            'position'      : 'Líder de Producción',
            'image'         : "/images/team/G_Paulina.jpg",
            'links'         : {
                'linkedin'  : 'https://www.linkedin.com/in/paulina-gatica-mondaca/'
            }
        },
        {
            'name'          : 'Catalina Marilao C.',
            'position'      : 'Diseñadora Instruccional',
            'image'         : "/images/team/DI_Catalina.jpg",
            'links'         : {
                'linkedin'  : 'https://cl.linkedin.com/in/cmarilao'
            }
        },
        {
            'name': 'Ecarinne González R.',
            'position': 'Diseñadora Instruccional',
            'image': "/images/team/DI_Ecarinne.jpg",
            'links': {
                'linkedin': 'https://www.linkedin.com/in/ecarinne-gonz%C3%A1lez-rodr%C3%ADguez-33282b10b/'
            }
        },
         {
            'name'          : 'Karla Cabello O.',
            'position'      : 'Diseñadora Instruccional',
            'image'         : "/images/team/DI_Karla.jpg",
            'links'         : {
                'linkedin'  : 'https://www.linkedin.com/in/karla-cabello-orellana/'
            }
        },
        {
            'name'          : 'Ronny Carvajal O.',
            'position'      : 'Diseñador Multimedia',
            'image'         : "/images/team/DG_Ronny.jpg",
            'links'         : {
                'linkedin'  : 'https://www.linkedin.com/in/ronny-carvajal-oyarzo-baa31929/'
            }
        },
        {
            'name'          : 'Anahí Aguirre S.',
            'position'      : 'Diseñadora Multimedia',
            'image'         : "/images/team/DG_Anahi.jpg",
            'links'         : {
                'linkedin'  : 'https://www.linkedin.com/in/nhsls/',
            }
        },
        {
            'name'          : 'Juan Guzmán L',
            'position'      : 'Audiovisualista',
            'image'         : "/images/team/AV_Juan.jpg",
            'links'         : {
                'linkedin'  : 'https://www.linkedin.com/in/juanguzm%C3%A1n5329052b/'
            }
        },
        {
            'name'          : 'Thomas Peet M.',
            'position'      : 'Líder de Ingeniería',
            'image'         : "/images/team/TI_Thomas.jpg",
            'links'         : {
                'linkedin'  : 'https://www.linkedin.com/in/thomaspeet/'
            }
        },
        {
            'name': 'Felipe Sologuren G.',
            'position': 'DevOps',
            'image': "/images/team/TI_Felipe.jpg",
            'links': {
                'linkedin': 'https://www.linkedin.com/in/felipe-sologuren-guti%C3%A9rrez-784b45b3/',
                'github': 'https://github.com/fsologureng'
            }
        },
        {
            'name': 'Vicente Astorga V.',
            'position': 'DevOps',
            'image': "/images/team/TI_Vicente.jpg",
            'links': {
                'linkedin': 'https://www.linkedin.com/in/vicente-astorga',
                'github': 'https://github.com/vicente-astorga'
            }
        }
    ]
}
